import React from 'react';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    transcript?: string;
}

const CallTranscriptModal = ({ transcript }: Props) => {
    const { i18next } = useAppContext();

    return (
        <BaseModal
            open={true}
            header={
                <span className="ps-3 text-lg text-gray-800">
                    {i18next.t('ai.transcript.transcript')}
                </span>
            }
            onClose={() => {}}
            disablePadding={false}
            disableActions={true}
            className="max-h-[780px] w-[600px]"
        >
            <div className="p-6">
                <p className="text-base">
                    <span className="whitespace-pre-wrap text-gray-600">
                        {transcript}
                    </span>
                </p>
            </div>
        </BaseModal>
    );
};

export default CallTranscriptModal;
